<template lang="pug">
#Results.overflow-y-auto(style="flex: 1 1; min-height:0")
    .group(v-for="(locationGroup) of locationGroups")
        h3.groupName(:data-groupName="locationGroup[0].properties.locationName || locationGroup[0].properties.orgName") {{ locationGroup[0].properties.locationName || locationGroup[0].properties.orgName }}
        div(v-if="locationGroup[0].dist") {{ Math.round(locationGroup[0].dist) }} km
        v-list
            v-list-item(v-for="item of locationGroup")
                Result(:item="item" :selected=" item.properties.id === selectedServiceId" :groupProperties="locationGroup[0].properties" @click="clickResult(item)" :windowWidth="windowWidth")



</template>

<script>
import { EventBus } from '@/EventBus';
import * as turf from '@turf/turf';
import Result from '@/components/Result.vue';
import mapboxgl from 'mapbox-gl';
import loadServicePoints from '@/servicePoints';

export default {
    name: 'Results',
    data: () => ({
        servicePoints: null,
        selectedServiceId: null,
    }),
    components: { Result },
    props: ['category', 'center', 'windowWidth'],
    async created() {
        window.Results = this;
        this.servicePoints = await loadServicePoints();
        EventBus.$on('result-pin-click', (e) => {
            EventBus.$emit(
                'result-click',
                this.items.find(
                    (item) => item.properties.id === +e.firstServiceId
                )
            );
        });
        EventBus.$on('result-click', async (e) => {
            console.log(e);
            this.selectedServiceId = +e.properties.id;
            const serviceEl = document.querySelector(
                `.result[data-serviceid="${this.selectedServiceId}"]`
            );
            if (serviceEl) {
                await this.$nextTick();
                serviceEl

                    .closest('.group')
                    .scrollIntoView({ behavior: 'smooth' });
            } else {
                console.log("This serviceId doesn't exist in the results list");
                console.log(this.getServicePoint(e.firstServiceId));
            }
        });
    },
    mounted() {},
    methods: {
        orgName(orgId) {
            const org = this.organisations.features.find(
                (org) => org.properties.orgId === orgId
            );
            return org.properties.name;
        },
        clickResult(item) {
            console.log(item);
            if (this.selectedPopup) {
                this.selectedPopup.remove();
            }
            this.selectedPopup = new mapboxgl.Popup({
                className: 'selectedPopup',
                closeButton: false,
            })
                .setHTML(
                    `<img src="${item.properties.icon}" /><span class="orgName">${item.properties.orgName}</span>`
                )
                .setLngLat(item.geometry.coordinates)
                .addTo(window.map);

            EventBus.$emit('result-click', {
                ...item,
            });
            window.map.flyTo({
                center: item.geometry.coordinates,
                zoom: 14,
            });
        },
        getServicePoint(id) {
            return this.servicePoints.find((sp) => sp.id === +id);
        },
    },
    computed: {
        locationGroups() {
            function groupLocations(services) {
                const groups = services.reduce((groups, service) => {
                    const groupId = [
                        service.properties.locationName ||
                            service.properties.orgId,
                    ];

                    return {
                        ...groups,
                        [groupId]: [
                            ...(groups[service.properties.locationName] || []),

                            service,
                        ],
                    };
                }, {});
                return groups;
            }
            if (!this.items) {
                return null;
            }
            const groups = Object.values(groupLocations(this.items));
            return groups.sort((a, b) => a[0].dist - b[0].dist);
        },
        // this is the source of truth for map pins
        items() {
            this.category; // Vue voodo
            if (!this.servicePoints || !this.center || !this.category) {
                return null;
            }
            const filter = (sp) =>
                !this.category ||
                this.category === '-' ||
                sp.properties[`category:${this.category}`] ||
                sp.properties[`category:${this.category}-phone`];

            const dist = (sp) => turf.distance(turf.point(this.center), sp);
            const sortFunc = (a, b) => a.dist - b.dist;
            const results = this.servicePoints
                .filter(filter)
                .map((sp) => JSON.parse(JSON.stringify(sp)))
                .map((sp) => {
                    const hasPhoneServices = Object.keys(
                        sp.properties
                    ).find((k) => k.match(/category:.*-phone/i));
                    if (
                        (sp.properties[`category:${this.category}-phone`] &&
                            !sp.properties[`category:${this.category}`]) ||
                        (this.category === '-' && hasPhoneServices)
                    ) {
                        sp.properties.phoneService = true;
                    }
                    sp.properties.icon = sp.properties.phoneService
                        ? 'other-assets@2x/remote-alt.png'
                        : sp.properties.type === 'servicePoint'
                        ? 'other-assets@2x/servicepoint.png'
                        : 'other-assets@2x/clinic-alt.png';

                    return sp;
                });
            if (this.center) {
                results.forEach((result) => (result.dist = dist(result)));
                results.sort(sortFunc);
            }
            return results.filter((sp) => !sp.dist || sp.dist < 300);
        },
        resultsBbox() {
            if (this.items) {
                return turf.bbox(
                    turf.featureCollection([
                        ...(this.center ? [turf.point(this.center)] : []),
                        ...this.items.slice(0, 5), //
                    ])
                );
            } else {
                return null;
            }
        },
    },
    watch: {
        resultsBbox() {
            if (this.resultsBbox) {
                EventBus.$emit('results-bbox', this.resultsBbox);
            }
        },
        items() {
            EventBus.$emit('results-change', {
                results: turf.featureCollection(this.items || []),
                center: this.center,
            });
            this.selectedServiceId = null;
            // if anything affects the results list, scroll back to the top
            try {
                this.$nextTick(() => {
                    document
                        // .querySelector('.group') // picks the first org
                        .querySelector('#Filters')
                        .scrollIntoView({ behavior: 'smooth' });
                });
            } catch {
                /* */
            }
        },
    },
};
</script>

<style>
.result a {
    text-decoration: none;
}

.org-name {
    font-size: 18px;
    /* line-height: 1; */
    margin-bottom: 0.5em;
}

.group {
    /* border-top: 1px solid grey; */
    /* border-bottom: 1px solid grey; */
    margin: 1em 0;
    padding: 0.5em;
}

.groupName {
    /* border-bottom: 1px solid gray; */
}

.org-phone {
    font-size: 14px;
}

.org-address {
    font-size: 14px;
}

.service-type {
    /* width: 50px; */
    /* background: grey; */
}

.selectedPopup .mapboxgl-popup-content {
    display: flex;
    border-radius: 100px;
    border: 1px solid hsl(208.9, 98.4%, 72%);
    padding: 6px 10px 4px;
    pointer-events: none;
}
.selectedPopup.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip {
    border-top-color: hsl(208.9, 98.4%, 72%);
}
.selectedPopup.mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: hsl(208.9, 98.4%, 72%);
}
.selectedPopup.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {
    border-right-color: hsl(208.9, 98.4%, 72%);
}
.selectedPopup.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {
    border-left-color: hsl(208.9, 98.4%, 72%);
}

.selectedPopup img {
    width: 36px;
    height: auto;
    object-fit: contain;
    flex-shrink: 0;
    /* flex-grow: 0; */
    flex-basis: 1;
    margin-left: 8px;
}

.selectedPopup .orgName {
    display: inline-block;
    vertical-align: center;
    font-size: 14px;
    margin-left: 10px;
    flex-shrink: 1;
    flex-grow: 1;
}
</style>
